import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import FolderIcon from "@material-ui/icons/Folder";
import GetAppIcon from "@material-ui/icons/GetApp";
import React from "react";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		maxWidth: 752,
	},
	demo: {
		backgroundColor: theme.palette.background.paper,
	},
	title: {
		margin: theme.spacing(4, 0, 2),
	},
}));

function generate(element) {
	return [0, 1, 2].map((value) =>
		React.cloneElement(element, {
			key: value,
		})
	);
}
const styled = { cursor: "noone" };

function displayinput(element, secondary, showDelete, { handleListClick }) {
	console.log("element=", element);
	console.log("secondary=", secondary);
	const elemlist = element.input[0].map((x) => x);
	console.log("elemlist=", elemlist);
	const handleListItemClick = (itemId) => {
		console.log("handleListItemClick clicked e.target.id", itemId);
		handleListClick(itemId);
	};
	return elemlist.map((value) => (
		<ListItem key={value._id} style={styled}>
			<ListItemAvatar>
				<Avatar>
					<FolderIcon />
				</Avatar>
			</ListItemAvatar>
			<ListItemText
				primary={value.file.name}
				secondary={secondary ? "Secondary text" : null}
			/>
			<ListItemSecondaryAction>
				<IconButton
					edge="end"
					aria-label="Open"
					onClick={() => handleListItemClick(value._id)}
				>
					<GetAppIcon />
				</IconButton>
				{showDelete ? (
					<IconButton edge="end" aria-label="delete">
						<DeleteIcon />
					</IconButton>
				) : (
					""
				)}
			</ListItemSecondaryAction>
		</ListItem>
	));
}

export default function InteractiveList(props) {
	const classes = useStyles();
	const [dense, setDense] = React.useState(false);
	const [secondary, setSecondary] = React.useState(true);

	const handleListClick = (value) => {
		console.log("handleListClick click value=", value);
		props.handleFileClick(value);
	};
	//console.log("inputs=", props);

	return (
		<div className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={6}>
					<div className={classes.demo}>
						<List dense={dense}>
							{displayinput(props, props.secondary, props.showDelete, {
								handleListClick,
							})}
						</List>
					</div>
				</Grid>
			</Grid>
		</div>
	);
}
